<div
  (click)="handleClick()"
  [ngClass]="[fullWidth ? 'tw-w-full' : 'tw-w-fit tw-max-w-72', 'tw-bg-' + bgColor, 'tw-text-' + textColor, disabled ? 'tw-opacity-30 tw-cursor-not-allowed' : '']"
  class="tw-min-w-max tw-h-fit tw-min-h-12 tw-flex tw-justify-center tw-items-center tw-gap-2 tw-rounded-[5px] tw-cursor-pointer tw-select-none tw-px-4 tw-py-2"
>
  <img *ngIf="src && src != ''" class="tw-w-6 tw-h-6 tw-object-contain" [src]="src" />
  <p class="tw-font-poppins tw-font-semibold tw-text-sm">{{ text | translate }}</p>
</div>
